import { render, staticRenderFns } from "./InformationFail.vue?vue&type=template&id=7b2dda25&scoped=true&"
import script from "./InformationFail.vue?vue&type=script&lang=js&"
export * from "./InformationFail.vue?vue&type=script&lang=js&"
import style0 from "./InformationFail.vue?vue&type=style&index=0&id=7b2dda25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2dda25",
  null
  
)

export default component.exports